import { render } from "./App.vue?vue&type=template&id=57530be9"
const script = {}

import "./App.vue?vue&type=style&index=0&id=57530be9&lang=css"
script.render = render

export default script